/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeDialogContext,
  BaSeGrid,
  BaSeGridItem,
  BaSeHeading6,
  BaSeParagraph,
  BaSeShapeButton,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { useRegionalService } from '../../../../../../hooks/services/regional-service';
import RegionalForm from '../../../candidates/dialogs/regional-form';
import { ContainerButton } from './table-style';

function OptionsRegional({ reloadData, isActive, id, name, fullData }) {
  const TITLE_BUTTON = isActive ? 'Desativar regional' : 'Ativar regional';
  const ICON_BUTTON = isActive
    ? 'system/forbid-line'
    : 'system/arrow-go-back-fill';

  const { changeStatusRegional } = useRegionalService();
  const { handleSuccess, handleError } = useMessage();
  const { showModal } = React.useContext(BaSeDialogContext);

  const returnText = React.useMemo(() => {
    return isActive ? (
      <BaSeParagraph color="#636363">
        Tem certeza que deseja <strong>desativar</strong> a regional{' '}
        <strong>{name}</strong>?
        <br /> Ao desativar uma regional, todas as turmas que possuem vínculo à
        regional serão desativadas.
      </BaSeParagraph>
    ) : (
      <BaSeParagraph color="#636363">
        Tem certeza que deseja ativar a regional <strong>{name}</strong>?
      </BaSeParagraph>
    );
  }, [isActive, name]);

  const openDialogNewRegional = React.useCallback(() => {
    return showModal({
      actions: [],
      size: 'small',
      title: `${TITLE_BUTTON}`,
      dismissible: true,
      dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
      dismissibleIconType: 'tertiary',
      breakpointDelimiter: 'mobileLarge',
      content: ({ closeModal, emitEvent }) => (
        <BaSeGrid>
          <BaSeGridItem size={12}>
            <BaSeHeading6
              color={BaSeTheme.colors.feedbackInterface.atencao55}
              isBold={true}
            >
              Atenção!
            </BaSeHeading6>
          </BaSeGridItem>
          <BaSeGridItem size={12}>{returnText}</BaSeGridItem>

          <BaSeGridItem size={2}>
            <BaSeButton
              value="Sim"
              color={BaSeTheme.colors.defaultColors.black}
              onClick={() => {
                changeStatusRegional(id, !isActive)
                  .then(() => {
                    handleSuccess('Operação realizada com sucesso!');
                  })
                  .then(() => {
                    closeModal();
                    reloadData();
                  })
                  .catch(() => {
                    handleError('Erro ao ativar/desativar regional.');
                  });
              }}
            />
          </BaSeGridItem>

          <BaSeGridItem size={2}>
            <BaSeButton
              value="Não"
              color={BaSeTheme.colors.defaultColors.black}
              type="secondary"
              onClick={() => closeModal()}
            />
          </BaSeGridItem>
        </BaSeGrid>
      ),
      onChooseAction: (action) => { },
      afterClose: () => { },
    });
  }, [
    TITLE_BUTTON,
    changeStatusRegional,
    handleError,
    handleSuccess,
    id,
    isActive,
    reloadData,
    returnText,
    showModal,
  ]);

  const openDialogEditRegional = React.useCallback(
    (fetchRefional) => {
      return showModal({
        actions: [],
        size: 'medium',
        title: 'Editar regional',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        breakpointDelimiter: 'mobileLarge',
        content: ({ closeModal, emitEvent }) => (
          <RegionalForm mode="edit"
            closeModal={closeModal}
            fetchRefional={reloadData}
            data={fullData}
          />
        ),
        onChooseAction: (action) => {
          reloadData();
        },
      });
    },
    [fullData, reloadData, showModal],
  );

  return (
    <ContainerButton>
      <BaSeShapeButton
        buttonType="button"
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
        nameIcon="design/pencil-line"
        onClick={() => openDialogEditRegional()}
        shape="square"
        size="medium"
        sizeIcon="medium"
        type="tertiary"
        tooltip={{
          width: '150',
          direction: 'top',
          message: `Editar regional`,
          color: `${BaSeTheme.colors.institucionais.cinzaSebrae60}`,
        }}
      />

      <BaSeShapeButton
        buttonType="button"
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
        nameIcon={ICON_BUTTON}
        onClick={() => openDialogNewRegional()}
        shape="square"
        size="medium"
        sizeIcon="medium"
        tooltip={{
          width: '150',
          direction: 'top',
          message: `${TITLE_BUTTON}`,
          color: `${BaSeTheme.colors.institucionais.cinzaSebrae60}`,
        }}
        type="tertiary"
      />
    </ContainerButton>
  );
}

export default OptionsRegional;
